import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SelectItemProps } from '@ui/src';
import { AccountType, Category, ReportSheet } from '../../types';
import { Banks } from '../types';
import { banksApi } from './services';
import formReport from '../../helpers/form-report';

export interface BankAndPspReportState {
  report?: ReportSheet[];
  itemsVisible: AccountType[];
  formationTime?: {
    start?: number;
    end?: number;
    duration?: number;
  };
  lists: {
    categories: SelectItemProps[];
    groups: SelectItemProps[];
    primaries: SelectItemProps[];
  };
  accountsCategories?: Category[];
}

const initialState: BankAndPspReportState = {
  report: undefined,
  itemsVisible: [],
  formationTime: undefined,
  lists: {
    categories: [],
    groups: [],
    primaries: [],
  },
};

export const bankAndPspReportSlice = createSlice({
  name: 'bankAndPspReport',
  initialState,
  reducers: {
    changeVisibility: (state, action: PayloadAction<AccountType[]>) => {
      state.itemsVisible = action.payload;
    },
    setBanksAccountsCategories: (state, action: PayloadAction<Category[]>) => {
      state.accountsCategories = action.payload;
    },
    clearBankAndPspReportState: (state) => {
      state.report = undefined;
      state.itemsVisible = [];
      state.formationTime = undefined;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(banksApi.endpoints.getBanksReport.matchPending, (state) => {
        state.formationTime = {
          start: Date.now(),
          end: undefined,
          duration: undefined,
        };
      })
      .addMatcher(
        banksApi.endpoints.getBanksReport.matchFulfilled,
        (
          state,
          action: PayloadAction<{ data: Banks }> & {
            meta: { fulfilledTimeStamp: number };
          },
        ) => {
          const accountCategories = state.accountsCategories;

          const reportResult = formReport({
            ...action.payload.data,
            accountCategories: accountCategories as Category[],
          });

          state.lists = reportResult.lists;
          state.report = reportResult.sheet;

          state.formationTime = {
            ...state.formationTime,
            end: action.meta.fulfilledTimeStamp,
            duration: Math.round(
              (action.meta.fulfilledTimeStamp -
                (state.formationTime?.start as number)) /
                1000,
            ),
          };
        },
      );
  },
});

export const {
  changeVisibility,
  clearBankAndPspReportState,
  setBanksAccountsCategories,
} = bankAndPspReportSlice.actions;

export default bankAndPspReportSlice.reducer;
